export const styles = {
  button: {
    margin: '2px',
    backgroundColor: '#87CEFA',
    '&:hover': {
      cursor: 'default',
 }, 
  },
};



// WEBPACK FOOTER //
// ./src/components/collectionCard/style.js